import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from "react-chartjs-2";

import { useConfig } from "../../../context/config-context";

const MetricGraph = ({ metrics, patient }) => {
  const siteConfig = useConfig();
  const tabConfig = siteConfig.components.patient_tabs.find(
    (t) => t.id === "metrics"
  );
  const graphs =
    process.env.REACT_APP_ECOSYSTEM === "parkinson"
      ? tabConfig.graphs(patient?.parkinsonType?.label)
      : tabConfig.graphs;

  Chart.register(ChartDataLabels);

  if (metrics) {
    return (
      <>
        {metrics.labels && Object.keys(metrics.labels).length === 0 && (
          <div className="w-full my-5 text-center text-neutral-dark">
            {tabConfig.none}
          </div>
        )}
        <div className="grid grid-cols-1 gap-2 lg:grid-cols-2">
          {graphs.map((graph, index) => (
            <div key={index} className={graph.className}>
              <graph.element
                data={graph.dataConfig(metrics, patient?.parkinsonType?.label)}
                options={graph.options}
                plugins={graph.plugins}
              />
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <div className="w-full my-5 text-center text-neutral-dark">
      {tabConfig.none}
    </div>
  );
};

export default MetricGraph;
